import { useCallback, useEffect, useRef, useState } from "react";

export const SPLIT_MIN = 180;
export const SPLIT_MAX = 480;
const clamp = (v) => Math.min(SPLIT_MAX, Math.max(SPLIT_MIN, Math.round(v)));

/* 可拖拽分栏宽度：localStorage 记忆 · 180–480px · reset() 恢复默认（双击分隔条） */
export function useSplitter(key, def) {
  const [w, setW] = useState(() => { const v = Number(localStorage.getItem(key)); return v >= SPLIT_MIN && v <= SPLIT_MAX ? v : def; });
  const [dragging, setDragging] = useState(false);
  const start = useRef(null);
  useEffect(() => { localStorage.setItem(key, String(w)); }, [key, w]);
  const onPointerDown = useCallback((e) => {
    if (e.button != null && e.button !== 0) return;
    e.preventDefault();
    start.current = { x: e.clientX, w };
    setDragging(true);
    const move = (ev) => setW(clamp(start.current.w + (ev.clientX - start.current.x)));
    const up = () => { start.current = null; setDragging(false); document.body.style.cursor = ""; document.body.style.userSelect = ""; window.removeEventListener("pointermove", move); window.removeEventListener("pointerup", up); window.removeEventListener("pointercancel", up); };
    document.body.style.cursor = "col-resize"; document.body.style.userSelect = "none";
    window.addEventListener("pointermove", move); window.addEventListener("pointerup", up); window.addEventListener("pointercancel", up);
  }, [w]);
  const reset = useCallback(() => setW(def), [def]);
  const onKeyDown = useCallback((e) => {
    if (e.key === "ArrowLeft") { e.preventDefault(); setW((x) => clamp(x - 16)); }
    else if (e.key === "ArrowRight") { e.preventDefault(); setW((x) => clamp(x + 16)); }
    else if (e.key === "Home" || e.key === "Enter") { e.preventDefault(); reset(); }
  }, [reset]);
  return { w, setW, dragging, onPointerDown, onKeyDown, reset };
}
